/*@ngInject*/
const ReloadRulesModalController = function ($rootScope, $scope, coreConstant, options, localization) {

    localization.getTranslationsByKeys([options.localizationRoot]).then(function (translations) {

        $scope.viewModel = {
            title: _.get(translations, 'title'),
            cancelButton: _.get(translations, 'cancel'),
            okButton: _.get(translations, 'confirm'),
            summary: _.get(translations, 'summary'),
            validateCheckBox: _.get(translations, 'validateCheckBox'),
            validate: false
        };

        $scope.onConfirm = function () {
            $scope.$close({
                validate: $scope.viewModel.validate
            });
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('ums.configuration')
    .controller('reloadRulesModalController', ReloadRulesModalController);
